import React from 'react';
const painPoints = ['Te sentás a trabajar y a los 10 minutos ya estás en Instagram sin darte cuenta', 'Tenés proyectos parados hace meses que "iban a cambiar todo" y nunca arrancaron', 'Llegás a la noche con ese nudo en el estómago sabiendo que el día se te escapó', 'Intentaste mil veces "ser más disciplinado" y siempre terminás en el mismo ciclo', 'Sabés exactamente lo que tendrías que hacer pero tu cerebro elige el scroll infinito', 'Tu potencial está intacto pero tu atención está secuestrada por un algoritmo de mil millones'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-176">
      <div className="mx-auto max-w-3xl" data-id="element-177">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-400 mb-2" data-id="element-178">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-white m-0 mb-6" data-id="element-179">
          Esto le pasa al 90% de las personas con talento
        </h2>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-180">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white/5 border border-red-500/20 rounded-lg p-3 shadow-sm" data-id="element-181">
              <span className="text-red-400 text-base leading-5 shrink-0" data-id="element-182">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-300 m-0" data-id="element-183">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-yellow-400 m-0 mb-6" data-id="element-184">
          ¿Cuántos días más vas a desperdiciar scrolleando?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(234,179,8), rgba(255,255,255,0))'
      }} data-id="element-185" />
      </div>
    </section>;
}